export const ROUTES = {
  // Public routes
  AUTHORIZE: '/authorize',
  LINK_EXPIRED: '/link-expired',

  // Protected routes
  HOME: '/',
  PAYMENT_DETAILS: '/payment-details',
  FINAL_DELIVERY: '/final-delivery',
  COMPLETION: '/completion',
} as const;

export type Route = (typeof ROUTES)[keyof typeof ROUTES];

export const LOCAL_STORAGE_KEYS = {
  ackPaperworkToken: 'vygr_ack_paperwork_token',
};

/** Query parameter carrying the signed token on the SMS link. */
export const TOKEN_QUERY_PARAM = 't';

export const JOURNEY_PROGRESS = {
  HOME: 25,
  PAYMENT_DETAILS: 50,
  FINAL_DELIVERY: 75,
  COMPLETION: 100,
} as const;

export const AMS_LOGO_SRC = '/ams-logo.svg';

/** Max content width — tablet portrait; does not expand on desktop */
export const TABLET_MAX_WIDTH_PX = 768;

export const PAYMENT_SIGNATURE_NAME = 'paymentCustomer.png';
export const ACK_SIGNATURE_NAME = 'ackFinalDelivery.png';
export const DEFAULT_SIGNATURE_AGREEMENT =
  'I agree my signature and/or typed name provided here will be legally binding and utilized throughout this entire digital document. Genuine signature required.';
export const MATERIALS_LABEL = 'Materials:';

export const BOL_PENDING_MESSAGE = 'Waiting for the Bill of Lading to be signed on the driver tablet.';
export const BOL_SIGNATURE_POLL_INTERVAL_MS = 30_000;
export const BOL_STATUS_ERROR_MESSAGE = 'Unable to check the Bill of Lading status.';

export const PAYMENT_SIGNATURE_CONFIG = {
  type: 'BOL',
  type2: 'final_payment',
  signerName: 'paymentCustomer.png',
  title: 'final_payment',
  pdfType: 'BOL',
  writeBolStatus: false,
} as const;

export const ACK_SIGNATURE_CONFIG = {
  type: 'ACK',
  type2: 'cust_ack',
  signerName: 'ackFinalDelivery.png',
  title: 'ackFinalDelivery',
  pdfType: 'ACK',
} as const;
